module.exports = __webpack_public_path__ + "static/media/waiting_room.c99e1533.webp";